import { environment } from '@lla-platform/core/core-util'

export const TARGETS_API_URL = {
  availableWeeks: `${environment.apiUrl}/dashboards/availableweeks`,
  shopsTargets: `${environment.apiUrl}/targets/locations-targets`,
  shopsTargetsComps: `${environment.apiUrl}/targets/locations-targets-comps`,
  shopsTargetsByPeriod: `${environment.apiUrl}/targets/locations-targets-by-period`,
  shopsTargetsByPeriodDetails: `${environment.apiUrl}/targets/locations-targets-by-period/details`,
  targetsHistory: `${environment.apiUrl}/targets/history`,
  targetsDailyAverage: `${environment.apiUrl}/targets/daily-average`,
  exportTargetsDailyAverage: `${environment.apiUrl}/targets/daily-average/export`,

  yearlyTargets: `${environment.apiUrl}/targets/filters/location-targets`,
  exportYearlyTargets: `${environment.apiUrl}/targets/filters/location-targets/export`,
  locationYearlyTargets: (locationId: string, year: number) =>
    `${environment.apiUrl}/targets/location/${locationId}/daily-targets/${year}`,

  // Admin APIs
  adminYearlyTargets: `${environment.apiUrl}/admin/filters/location-targets`,
  adminExportYearlyTargets: `${environment.apiUrl}/admin/filters/location-targets/export`,
  adminLocationDailyTargets: (locationId: string, year: number) =>
    `${environment.apiUrl}/admin/location/${locationId}/daily-targets/${year}`,
  adminSaveLocationDailyTargets: (locationId: string) =>
    `${environment.apiUrl}/admin/location/${locationId}/daily-targets`,

  adminMonthlyTargets: `${environment.apiUrl}/admin/filters/location-monthly-targets`,
  adminExportMonthlyTargets: `${environment.apiUrl}/admin/filters/location-monthly-targets/export`,
  adminLocationMonthlyTargets: (locationId: string, year: number) =>
    `${environment.apiUrl}/admin/location/${locationId}/monthly-targets/${year}`,
  adminSaveLocationMonthlyTargets: (locationId: string) =>
    `${environment.apiUrl}/admin/location/${locationId}/monthly-targets`,

  adminAutoGenerateDailyTargetsPreview: `${environment.apiUrl}/admin/targets/auto-daily/preview`,
  adminAutoGenerateDailyTargetsApply: `${environment.apiUrl}/admin/targets/auto-daily/apply`,

  adminWeeklyTargets: `${environment.apiUrl}/admin/targets/weekly`,
  adminMonthlyViewTargets: `${environment.apiUrl}/admin/targets/monthly`,

  adminExportWeeklyTargets: `${environment.apiUrl}/admin/targets/weekly/export`,
  adminExportMonthlyViewTargets: `${environment.apiUrl}/admin/targets/monthly/export`
}
